import React from 'react';
const PURCHASE_URL = 'https://creatinadesdecero.com/products/libro?variant=50009032786113';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  size?: 'default' | 'large';
  href?: string;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  size = 'default',
  href = PURCHASE_URL
}: CTAButtonProps) {
  const sizeClasses = size === 'large' ? 'px-12 py-5 text-xl' : 'px-8 py-4 text-lg';
  return <a href={href} target="_blank" rel="noopener noreferrer" onClick={onClick} className={`inline-block text-center ${sizeClasses} bg-[#2F6BFF] hover:bg-[#1F54D8] text-white font-bold rounded-lg transition-all duration-300 transform hover:scale-105 hover:shadow-2xl hover:shadow-blue-500/50 ${className}`} aria-label={typeof children === 'string' ? children : 'Call to action button'} data-id="element-53">
      {children}
    </a>;
}